import styled from 'styled-components';
import { DEVICES } from '@thinknet-gmbh/platform-common-ui';

export const QuestionnaireLayoutWrapper = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 99;
  background-color: ${({ theme }) => theme.colors.tone.background};
  height: 100%;
  overflow: hidden;
  display: flex;
  padding: 40px 70px;
  @media ${DEVICES.md} {
    padding: 16px 16px 28px 16px;
  }
  @media ${DEVICES.sm} {
    height: 100%;
  }
`;
